// extracted by mini-css-extract-plugin
module.exports = {"AdSlotMail__mail":"bgv_a bht_vf bht_a bht_q bht_k","AdSlotMail__mail--notLoaded":"bgv_b bht_eu bht_bj bht_vu","show-ad-not-loaded":"bgv_c","AdSlotMail__cta":"bgv_e"};